<template>
  <a-drawer
:maskClosable="false"
width="65%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      :model="form"
      ref="form"
      :label-col="{ span: 3 }"
      :rules="rules"
      :wrapper-col="{ span: 10 }"
      class="padding-lr"
    >
      <a-tabs tab-position="top" v-model="tabIndex">
        <a-tab-pane :key="1" tab="基础信息">
          <a-row :gutter="12">
            <a-col :span="24">
              <a-form-model-item label="维修分类" prop="categoryId" class="margin-bottom-10">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="form.categoryId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in cateList" :key="d.id">{{ d.categoryName }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item label="维修品名称" prop="prodName" class="margin-bottom-10">
                <a-input v-model="form.prodName" placeholder="请输入" />
              </a-form-model-item>
              <!-- <a-form-model-item label="是否推荐" prop="isRecommend">
                <a-radio-group v-model="form.isRecommend" button-style="solid">
                  <a-radio-button :value="true"> 是 </a-radio-button>
                  <a-radio-button :value="false"> 否 </a-radio-button>
                </a-radio-group>
              </a-form-model-item> -->
              <a-form-model-item label="商品简述" prop="brief">
                <a-input v-model="form.brbriefief" type="textarea" placeholder="请输入" :maxLength="500" allow-clear />
              </a-form-model-item>
              <a-form-model-item label="主图" prop="pic">
                <file-upload
                  type="image"
                  :defaultList="form.pic"
                  @input="getImg($event, 'pic')"
                  :file="form.pic"
                  :count="1"
                  :autoCropHeight="210"
                  :autoCropWidth="164"
                ></file-upload>
              </a-form-model-item>
              <a-form-model-item label="商品图册" prop="img">
                <file-upload
                  type="image"
                  :defaultList="form.img"
                  @input="getImg($event, 'img')"
                  :file="form.img"
                  :count="6"
                  :autoCropHeight="350"
                  :autoCropWidth="350"
                ></file-upload>
              </a-form-model-item>
              <!-- <a-form-model-item label="添加视频" class="margin-bottom-10">
                <a-switch v-model="form.isVideo" checked-children="开启" un-checked-children="关闭" />
              </a-form-model-item> -->
              <div v-if="form.isVideo">
                <a-form-model-item label="视频类型4" class="margin-bottom-10" prop="video">
                  <a-radio-group v-model="form.videoType" button-style="solid" @change="changeVideo">
                    <a-radio-button :value="1"> 本地视频 </a-radio-button>
                    <a-radio-button :value="2"> 视频链接 </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="12">
                    <!-- <a-upload
                      v-if="form.videoType === 1"
                      action=""
                      list-type="picture-card"
                      :file-list="fileList"
                      @preview="handlePreview"
                      @change="uploadImages"
                    >
                      <div v-if="fileList.length < 1">
                        <a-icon type="video-camera" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload> -->
                    <file-upload
                      v-if="form.videoType === 1"
                      type="video"
                      :defaultList="form.video"
                      @input="getImg($event, 'video')"
                      :file="form.video"
                      :count="1"
                      :autoCropHeight="350"
                      :isUpload="false"
                      :autoCropWidth="750"
                    ></file-upload>
                    <div v-if="form.videoType === 2" style="height: 93px; padding-top: 20px">
                      <a-input placeholder="请输入视频链接" v-model="form.video"></a-input>
                    </div>
                  </a-col>
                </a-row>
              </div>
              <a-divider></a-divider>
              <a-row style="margin: 30px 0">
                <a-col :span="2"></a-col>
                <a-col :span="12" class="margin-tb-lg">
                  <a-button type="primary" size="large" @click="changeTab(1, 'next')">下一步</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="规格库存">
          <!-- <a-form-model-item class="margin-bottom-10" label="商品规格">
            <a-radio-group v-model="form.isSpec" button-style="solid" @change="changeSpec">
              <a-radio-button :value="0"> 单规格 </a-radio-button>
              <a-radio-button :value="1"> 多规格 </a-radio-button>
            </a-radio-group>
          </a-form-model-item> -->
          <div v-show="form.isSpec === 0">
            <a-form-model-item class="margin-bottom-10" label="原价" prop="oriPrice">
              <a-input v-model="form.oriPrice" oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\d*\.\d{0,2}).*$/g,'$1')" placeholder="请输入" suffix="￥" />
            </a-form-model-item>
             <a-form-model-item class="margin-bottom-10" label="现价" prop="price">
              <a-input v-model="form.price" oninput="value=value.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\d*\.\d{0,2}).*$/g,'$1')" placeholder="请输入" suffix="￥" />
            </a-form-model-item>
            <!-- <a-form-model-item class="margin-bottom-10" label="库存" prop="totalStocks">
              <a-input
                v-model="form.totalStocks"
                placeholder="请输入"
                oninput="this.value=this.value.replace(/\D/g,'').replace(/^0+/,'')"
              />
            </a-form-model-item> -->
            <a-form-model-item class="margin-bottom-10" label="排序" prop="sort">
              <a-input v-model="form.sort" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" />
            </a-form-model-item>
          </div>
          <div v-show="form.isSpec === 1">
            <a-form-model-item label="请选择规格">
              <a-select
                v-model="curSpec"
                show-search
                placeholder="请选择规格"
                style="width: 200px"
                @change="handleChangeSpec"
              >
                <a-select-option :value="item.id" v-for="(item, index) in form.specList" :key="index">
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <a-button v-if="curSpec" type="primary" @click="isShowSpec = true">确定</a-button>
            </a-form-model-item>
            <!-- start展示选择的规格信息 -->
            <div v-if="isShowSpec && form.specList.length">
              <div class="box margin-bottom-sm" v-for="(item, index) in form.specList[0].specs" :key="index">
                <div class="margin-bottom-xs">
                  {{ item.label }}
                  <a-icon type="close-circle" class="cursorhand margin-left-sm" @click="delSpec(index)" />
                </div>
                <div class="flex align-center">
                  <div v-for="(item1, index1) in item.spec_value" :key="index" class="flex align-center">
                    <a-input v-model="item1.label" placeholder="请输入" size="small" style="width: 80%" />
                    <a-button
                      v-if="index1 + 1 === item.spec_value.length"
                      type="primary"
                      size="small"
                      @click="add(2, index, index1)"
                      class="margin-left-sm margin-right"
                    >
                      添加
                    </a-button>
                    <a-icon
                      type="close-circle"
                      class="cursorhand margin-left-sm"
                      @click="del(2, index, index1)"
                    ></a-icon>
                  </div>
                </div>
              </div>
            </div>
            <!-- end  展示选择的规格信息 -->
            <a-button class="margin-tb" type="primary" @click="generateSpecs">立即生成</a-button>
            <!-- start 根据所选的规格，生成skuList,展示表格 -->
            <a-table
              :loading="loading"
              size="small"
              rowKey="postId"
              :columns="skuColumns"
              :data-source="skuList"
              :pagination="false"
              :bordered="true"
            >
              <!-- <div slot="key_name" slot-scope="text, record">{{  }}</div> -->
              <div slot="price" slot-scope="text, record">
                <a-input placeholder="请输入"></a-input>
              </div>
              <div slot="market_price" slot-scope="text, record">
                <a-input placeholder="请输入"></a-input>
              </div>
              <div slot="stock" slot-scope="text, record">
                <a-input-number placeholder="请输入"></a-input-number>
              </div>
              <div slot="weight" slot-scope="text, record">
                <a-input placeholder="请输入"></a-input>
              </div>
            </a-table>
            <!-- end   根据所选的规格，生成skuList,展示表格 -->
          </div>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="changeTab(2, 'back')" size="large" class="margin-right">上一步</a-button>
              <a-button @click="changeTab(2, 'next')" type="primary" size="large">下一步</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="其他设置">
          <a-form-model-item label="商品详情" prop="content" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <editor v-model="form.content" />
          </a-form-model-item>
          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="submitForm" type="primary" size="large">保存</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/repairModule/repairProducts'
import editor from '@/components/Editor/Editor.vue'
export default {
  name: 'CreateForm',
  props: {
    // statusOptions: {
    //   type: Array,
    //   required: false,
    // },
    cateList: {
      type: Array,
      required: true,
    },
  },
  components: { editor },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      submitLoading: false,
      tabIndex: 1,
      formTitle: '',
      form: {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        fileImgs: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1, // 1本地视频 2视频链接
      },
      isShowSpec: false,
      // 生成的skuList表格数据
      skuColumns: [
        {
          title: '规格',
          dataIndex: 'key_name',
          align: 'center',
          scopedSlots: { customRender: 'key_name' },
        },
        {
          title: '价格',
          dataIndex: 'price',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '市场价格',
          dataIndex: 'market_price',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'market_price' },
        },
        {
          title: '库存',
          dataIndex: 'stock',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'price' },
        },
        {
          title: '重量',
          dataIndex: 'weight',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'weight' },
        },
      ],
      curSpec: undefined,
      skuList: [],
      replaceFields: {
        title: 'label',
        key: 'id',
        value: 'id',
        children: 'children',
      },
      statusOptions: [
        {
          label: '上架',
          value: 1,
        },
        {
          label: '下架',
          value: 0,
        },
      ],
      status: 1,
      // 上传图片
      open: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      rules: {
        // goldBeansPrice: [{ required: true, message: '请输入商品金豆', trigger: 'blur' }],
        // totalStocks: [{ required: true, message: '请输入总库存', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        prodName: [{ required: true, message: '请输入维修品名称', trigger: 'blur' }],
        oriPrice: [{ required: true, message: '请输入商品原价', trigger: 'blur' }],
        fileImgs: [{ required: true, message: '请上传商品相册', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择商品分类', trigger: 'blur' }],
        brief: [{ required: true, message: '请输入商品简介', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传商品主图', trigger: 'blur' }],
        scorePrice: [{ required: true, message: '请输入商品积分', trigger: 'blur' }],
        price: [{ required: true, message: '请输入现价', trigger: 'blur' }],
        content: [{ required: true, message: '请输入商品详情', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    changeSpec(e) {
      const value = e.target.value
      this.form.isSpec = value
    },
    changeTab(index, type) {
      if (type === 'next') {
        this.tabIndex = index + 1
      } else if (type === 'back') {
        this.tabIndex = index - 1
      }
    },
    changeVideo(e) {
      console.log('切换', e)
      const value = e.target.value
      this.isVideo = value
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },
    showInputs() {
      this.inputVisibles = true
      this.$nextTick(function () {
        this.$refs.inputs.focus()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 选择省
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    /** 切换单规格还是多规格 **/
    handleChangeSpec(e) {
      console.log('选中规格', e)
      this.curSpec = e
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        categoryId: undefined,
        content: undefined,
        fileImgs: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1, // 1本地视频 2视频链接
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd(e) {
      this.tabIndex = 1
      this.reset()
      this.open = true
      if (e) {
        this.form.categoryId = e
      }
      this.formTitle = '添加商品'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.tabIndex = 1
      this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        console.log(response.data, 'response.data')
        response.data.isSpec = 0
        this.form = response.data
        this.open = true
        this.formTitle = '修改商品'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      // if(this.form.goldBeansPrice==0&& this.form.scorePrice==0) return this.$message.error('积分或金豆至少有一个不为0')
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}
.ant-tabs-bar {
  border: none !important;
  /* 取消元素的阴影效果 */
  box-shadow: none !important;
  height: 45px !important;
  padding-top: 5px !important;
}
</style>
